import { render, staticRenderFns } from "./MemberAdd.vue?vue&type=template&id=a8fb250c&scoped=true&"
import script from "./MemberAdd.vue?vue&type=script&lang=js&"
export * from "./MemberAdd.vue?vue&type=script&lang=js&"
import style0 from "./MemberAdd.vue?vue&type=style&index=0&id=a8fb250c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fb250c",
  null
  
)

export default component.exports